module.exports = __webpack_public_path__ + "static/alineacion-estrategia-a994b4186320dcca558531da6d89765f.png";